import { preferredLanguages } from '~/data/types/preferredUnits'
import type { PreferredLanguage } from '~/data/types/preferredUnits'

const CACHE_KEY = 'i18n.preferredLanguage'

const VALID_LANGUAGES: ReadonlySet<PreferredLanguage> = new Set(preferredLanguages)

function isPreferredLanguage(value: string): value is PreferredLanguage {
  return (VALID_LANGUAGES as ReadonlySet<string>).has(value)
}

export function readCachedPreferredLanguage(): PreferredLanguage | undefined {
  if (typeof window === 'undefined') return undefined
  try {
    const value = window.localStorage.getItem(CACHE_KEY)
    if (value && isPreferredLanguage(value)) {
      return value
    }
  } catch {
    // localStorage may be unavailable (private mode, disabled, quota)
  }
  return undefined
}

export function writeCachedPreferredLanguage(language: PreferredLanguage | null | undefined): void {
  // Clear the cache when the user has no preference so a previous value (from
  // a different user on a shared device, or after a user clears their
  // preference) can't shadow envConfig.defaultLanguage on next boot.
  if (!language) {
    clearCachedPreferredLanguage()
    return
  }
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(CACHE_KEY, language)
  } catch {
    // localStorage may be unavailable (private mode, disabled, quota)
  }
}

export function clearCachedPreferredLanguage(): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.removeItem(CACHE_KEY)
  } catch {
    // localStorage may be unavailable (private mode, disabled, quota)
  }
}
